import axios from '../Axios/Default';
import { handleResponse, setFilterAnd } from '../Utils/Utils';

export const getAppList = (_params, onSuccess, onError) => {
    const params = setFilterAnd(_params, 'type', 'app');
    const response = axios.get(`v1/admin/app`, { params });
    return handleResponse(response, onSuccess, onError)
}

export const createAppList = (data, onSuccess, onError) => {
    data.type = 'app';
    const request = axios.post(`v1/admin/app`, data);
    return handleResponse(request, onSuccess, onError);
}

export const getImageFunc = (_params, onSuccess, onError) => {
    const params = setFilterAnd(_params, 'type', 'image');
    const response = axios.get(`v1/admin/app`, { params });
    return handleResponse(response, onSuccess, onError)
}

export const createImageFunc = (data, onSuccess, onError) => {
    data.type = 'image';
    const request = axios.post(`v1/admin/app`, data);
    return handleResponse(request, onSuccess, onError);
}

export const getVideoFunc = (_params, onSuccess, onError) => {
    const params = setFilterAnd(_params, 'type', 'video');
    const response = axios.get(`v1/admin/app`, { params });
    return handleResponse(response, onSuccess, onError)
}

export const createVideoFunc = (data, onSuccess, onError) => {
    data.type = 'video';
    const request = axios.post(`v1/admin/app`, data);
    return handleResponse(request, onSuccess, onError);
}

export const updateAppList = (id, data, onSuccess, onError) => {
    const request = axios.put(`v1/admin/app/${id}`, data);
    return handleResponse(request, onSuccess, onError);
}

export const deleteAppList = (id, onSuccess, onError) => {
    const request = axios.delete(`v1/admin/app/${id}`);
    return handleResponse(request, onSuccess, onError);
}

export const softDeleteAppList = (id, data, onSuccess, onError) => {
    const request = axios.put(`v1/admin/app/${id}/delete`, data);
    return handleResponse(request, onSuccess, onError);
}


export const getDasboard = (onSuccess, onError) => {
    const request = axios.get('v1/admin/app/dashboard');
    return handleResponse(request, onSuccess, onError);
}

export const getLogs = (params, onSuccess, onError) => {
    const request = axios.get('v1/admin/app/sap/logs', { params });
    return handleResponse(request, onSuccess, onError);
}

export const getLog = (id, onSuccess, onError) => {
    const request = axios.get(`v1/admin/app/sap/log/${id}`);
    return handleResponse(request, onSuccess, onError);
}